import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { redirect } from 'redux-first-router'

import { DEFAULT_JOBS_QUERY_PARAMS } from 'constants/projects'
import { getUser } from 'ducks/auth'
import { toProjects } from 'ducks/router'
import { useLocation } from 'hooks'
import { getTab, TAB_NAMES } from './model'

export const TemplatesCreator = () => {
  const { first_name, last_name } = useSelector(getUser)

  const {
    payload: { tab, uuid },
  } = useLocation()

  const dispatch = useDispatch()

  const userName = `${first_name} ${last_name}`

  const hasInvalidTab = tab == null || tab !== TAB_NAMES.INTERVIEWS

  if (hasInvalidTab) {
    dispatch(redirect(toProjects(null, null, DEFAULT_JOBS_QUERY_PARAMS)))
  }

  const page = getTab({ tab, userName, uuid }, dispatch)

  return <React.Fragment>{page}</React.Fragment>
}
